const base64 = require('base64-js');

exports.toUrlBase64 = function toUrlBase64(arr) {
	return base64
		.fromByteArray(arr)
		.replace(/[+]/g, '-')
		.replace(/[/]/g, '_')
		.replace(/[=]/g, '');
};
